<template>
	<div id="content">
		<div class="wrapper">
			<h1>Impressum</h1>
			<p>CarMarkt (Mark Purushotham)<br />
			Oberhausener Straße 213<br />
			45476 Mülheim an der Ruhr<br />
			0172 / 217 88 78<br />
			info@carmarkt.net</p>

			<h2>Ansprechpartner für diesen Internetauftritt:</h2>
			<p>Dion Purushotham<br />
			Kassenberg 49<br />
			45479 Mülheim an der Ruhr<br />
			info@drpdev.de</p>
			<p><router-link to="/privacy" class="btn">Datenschutzerklärung</router-link></p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Imprint'
}
</script>
